import {apiMemberserviceEndpoint} from '@/config/config.js';
import { createApiClient } from "@/services/baseservice.js"

const apiScope = 'api://memberservice-api/Member.Read'

const baseservice = createApiClient(apiScope, apiMemberserviceEndpoint)

export default {
    async update(bankDataId, bankData) {
        return await baseservice.put('/bankdatas/' + bankDataId, bankData,
        { baseURL: apiMemberserviceEndpoint })
    },
};


